(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('verify', {
                parent: 'entity',
                url: '/verify',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'DBHawk Cloud Application'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/instance-dbh/verify.html',
                        controller: 'InstanceDbhController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                }
            })
        .state('instance-dbh', {
            parent: 'entity',
            url: '/instance-dbh?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'DBHawk Cloud Application'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/instance-dbh/instancesdbh.html',
                    controller: 'InstanceDbhController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        }).state('instances', {
                parent: 'entity',
                url: '/instances?page&sort&search&tab',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'DBHawk: Instances'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/instance-dbh/instancesdbh-list.html',
                        controller: 'InstanceListDbhController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                }
            }).state('instances.full_access', {
                parent: 'instances',
                url: '/full-access',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'DBHawk: Full Access'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/instance-dbh/full-access-form.html',
                        controller: 'InstanceListDbhController',
                        controllerAs: 'vm'
                    }
                }
            })
        .state('instance-dbh-detail', {
            parent: 'instance-dbh',
            url: '/instance-dbh/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Instance'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/instance-dbh/instance-dbh-detail.html',
                    controller: 'InstanceDbhDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Instance', function($stateParams, Instance) {
                    return Instance.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'instance-dbh',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('instance-dbh-detail.edit', {
            parent: 'instance-dbh-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instance-dbh/instance-dbh-dialog.html',
                    controller: 'InstanceDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Instance', function(Instance) {
                            return Instance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('instance-dbh.new', {
            parent: 'instance-dbh',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instance-dbh/instance-dbh-dialog.html',
                    controller: 'InstanceDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                instanceId: null,
                                name: null,
                                active: null,
                                cidrBlock: null,
                                dbhawkUrl: null,
                                publicDns: null,
                                region: null,
                                securityGrp: null,
                                status: null,
                                subnetId: null,
                                tag: null,
                                userId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('instance-dbh', null, { reload: 'instance-dbh' });
                }, function() {
                    $state.go('instance-dbh');
                });
            }]
        })
        .state('instance-dbh.edit', {
            parent: 'instance-dbh',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instance-dbh/instance-dbh-dialog.html',
                    controller: 'InstanceDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Instance', function(Instance) {
                            return Instance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('instance-dbh', null, { reload: 'instance-dbh' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('instance-dbh.delete', {
            parent: 'instance-dbh',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instance-dbh/instance-dbh-delete-dialog.html',
                    controller: 'InstanceDbhDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Instance', function(Instance) {
                            return Instance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('instance-dbh', null, { reload: 'instance-dbh' });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('instances.invite', {
            parent: 'instances',
            url: '/{company}/{instance}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instance-dbh/invite.html',
                    controller: 'InviteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Instance', function(Instance) {
                             return {
                                instance: $stateParams.instance,
                                company: $stateParams.company
                            };//Instance.get({id : $stateParams.id, company:$stateParams.company}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('instances', null, { reload: 'instances' });
                }, function() {
                    $state.go('instances');
                });
            }]
        }).state('instances.admin', {
                parent: 'instances',
                url: '/admin/{company}/{instance}/{dbhawkUrl}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/instance-dbh/inviteAdmin.html',
                        controller: 'InviteController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: ['Instance', function(Instance) {
                                return {
                                    instance: $stateParams.instance,
                                    company: $stateParams.company
                                };
                            }]
                        }
                    }).result.then(function() {
                        $state.go('instances', null, { reload: 'instances' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            }).state('instances.peering1', {
            parent: 'instances',
            url: '/peering/new/{instanceId}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/peering/peering-dialog.html',
                    controller: 'PeeringDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        /*entity: ['Peering', function(Peering) {
                            return {
                                instanceId: $stateParams.instanceId
                            };
                        }]*/
                        entity: function () {
                            return {
                                instanceId: $stateParams.instanceId
                            };
                        }


                    }
                }).result.then(function() {
                    $state.go('instances', {tab: 'peering'}, { reload: 'instances' });
                }, function() {
                    $state.go('instances');
                });
            }]
        }).state('instances.peeringdelete', {
                parent: 'instances',
                url: '/peering/delete/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/peering/peering-delete-dialog.html',
                        controller: 'PeeringDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Peering', function(Peering) {
                                return Peering.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('instances', null, { reload: 'instances' });
                    }, function() {
                        $state.go('^');
                    });
                }]
        }).state('instances.ipaddress', {
            parent: 'instances',
            url: '/ipaddress/add/{instanceId}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ipaddress/ipaddress-dialog.html',
                    controller: 'IpAddressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                instanceId: $stateParams.instanceId
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('instances', {tab: 'addresses'}, { reload: 'instances' });
                }, function() {
                    $state.go('instances');
                });
            }]
        }).state('instances.ipaddressdelete', {
            parent: 'instances',
            url: '/ipaddress/delete/{instanceId}/{ipAddress}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ipaddress/ipaddress-delete-dialog.html',
                    controller: 'IpAddressDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                instanceId: $stateParams.instanceId,
                                ipAddress: $stateParams.ipAddress
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('instances', null, { reload: 'instances' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
